<script>
    import members from "../stores/members";
    import groups from "../stores/groups";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import {memberDelete} from "../requests";
    import {createEventDispatcher} from 'svelte/internal';

    export let member = null;

    const dispatch = createEventDispatcher();

    const toggleMember = () => {
        member.selected = !member.selected;
        dispatch('toggle', member);
    }

    const editMember = () => {
        dispatch('edit', member);
    }

    const deleteMember = () => {
        app_alert.show('confirm', `Να διαγραφεί η επαφή "${member.lname} ${member.fname}";`, async () => {
            const [err, res] = await memberDelete(member.id);
            if (err) {
                return;
            }
            members.deleteMember(member.id);
            success.show("Η επαφή διαγράφτηκε.");

            // remove member from groups total phones
            member.in_groups.map(group_id => {
                let group = $groups.list.find( x=> x.id == group_id);
                if (group.total_mobiles > 0) {
                    group.total_mobiles--;
                }
            });
            $groups.list = $groups.list;

            dispatch('delete', member);
        });
    }
</script>

<div class="member-toggle-control" class:checked={ member.selected } on:click="{ toggleMember }">
    <div class="icon">
        <i class="fa fa-check"></i>
    </div>
    <div class="label">
        { member.lname } { member.fname }
        {#if member.occupation}
            <div class="occupation">
                { member.occupation }
            </div>
        {/if}
        <div class="mobile">
            { member.mobile }
        </div>
    </div>

    <div class="action action-edit" class:action-hide={ member.selected } title="Επεξεργασία ομάδας"
         on:click|stopPropagation="{ () => members.editMember(member.id, editMember) }"><i class="fa fa-edit"></i></div>
    <div class="action action-delete" class:action-hide={ member.selected } title="Διαγραφή ομάδας"
         on:click|stopPropagation="{ deleteMember }"><i class="fa fa-trash-o"></i></div>

</div>


<style>
    .member-toggle-control {
        position: relative;
        background: #fff;
        font-size: 14px;
        color: #767676;
        border: 1px solid #f3f3f3;
        border-radius: 3px;
        padding: 10px 15px;
        margin-top: 2px;
        overflow: hidden;
        cursor: pointer;
    }

    .member-toggle-control:after {
        content: "";
        clear: both;
        display: table;
    }

    .member-toggle-control .icon {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 30px;
        max-width: 0;
        background: #efefef;
        font-size: 10px;
        padding-top: 2px;
        opacity: 0;
        overflow: hidden;
        transition: .1s all ease;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }

    .member-toggle-control .icon i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .member-toggle-control .label {
        width: 100%;
        max-width: 100%;
        transition: .1s all ease;
    }

    .member-toggle-control .label .occupation {
        font-size: 12px;
        color: #a5a5a5;
    }

    .member-toggle-control.checked {
        /*background: #f1f1f1;*/
        color: #000;
        border-color: #e4e4e4;
    }

    .member-toggle-control.checked .icon {
        max-width: 40px;
        opacity: 1;
    }

    .member-toggle-control.checked .label {
        transition: .1s all ease;
        padding-left: 25px;
    }

    .member-toggle-control .action {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        width: 40px;
        color: #767676;
        background: #fff;
        border-left: 1px solid #f3f3f3;
        padding: 5px 8px;
        transition: .1s all ease;
        cursor: pointer;
    }

    .member-toggle-control .action:hover {
        color: #757575;
        background: #eee;
    }

    .member-toggle-control .action i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .member-toggle-control .action.action-edit {
        right: 40px;
    }

    .member-toggle-control .action.action-delete {
        color: #ff0000;
    }

    .member-toggle-control .action.action-hide {
        right: -40px;
    }
</style>